import React from "react";
import classes from "./Header.module.css";

export const Header = () => {
  return (
    <header className={classes.Header}>
      <p>George FX</p>
    </header>
  );
};
